'use client';
import './SongPlayer.css';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

function SongPlayer() {
  const pathname = usePathname();
  const isHome = pathname === '/';
  const posters = isHome ? ['_10'] : ['_1', '_2', '_3', '_4', '_5', '_6', '_7', '_8', '_9', '_10', '_11', '_12', '_13', '_14', '_15'];

  useEffect(() => {
    let playerTrack = document.getElementById('player-track'),
      bgArtwork = document.getElementById('bg-artwork'),
      bgArtworkUrl,
      albumName = document.getElementById('album-name'),
      trackName = document.getElementById('track-name'),
      albumArt = document.getElementById('album-art'),
      sArea = document.getElementById('s-area'),
      seekBar = document.getElementById('seek-bar'),
      trackTime = document.getElementById('track-time'),
      insTime = document.getElementById('ins-time'),
      sHover = document.getElementById('s-hover'),
      playPauseButton = document.getElementById('play-pause-button'),
      // i = playPauseButton.querySelector("svg"),
      tProgress = document.getElementById('current-time'),
      tTime = document.getElementById('track-length'),
      seekT,
      seekLoc,
      seekBarPos,
      cM,
      ctMinutes,
      ctSeconds,
      curMinutes,
      curSeconds,
      durMinutes,
      durSeconds,
      playProgress,
      bTime,
      nTime = 0,
      buffInterval = null,
      tFlag = false,
      trackNames = isHome
        ? ["Can't Help Falling In Love"]
        : [
            'Unchained Melody',
            "Can't Take My Eyes Off You",
            "I Won't Last A Day Without You",
            'Close To You',
            'Top Of The World',
            "There's A Kind Of Hush",
            'More Than Words',
            'I Just Called To Say I Love You',
            'Heaven',
            "Can't Help Falling In Love",
            'She',
            'Stand By Me',
            'Sandwichito de miga',
            'Almidón',
            'El Frodinguis',
          ],
      authors = isHome
        ? ['Elvis Presley']
        : [
            'Righteous Brothers',
            'Engelbert Humperdinck',
            'Carpenters',
            'Carpenters',
            'Carpenters',
            'Carpenters',
            'Extreme',
            'Stevie Wonder',
            'Boyce AvenueMegan Nicole',
            'Elvis Presley',
            'Elvis Costello',
            'Ben E. King',
            'Valentina Bringas',
            'Matías Bubello & Valentina Bringas',
            'Matías Bubello',
          ],
      albumArtworks = isHome ? ['_10'] : ['_1', '_2', '_3', '_4', '_5', '_6', '_7', '_8', '_9', '_10', '_11', '_12', '_13', '_14', '_15'],
      trackUrl = isHome
        ? ['./assets/songs/music/10.mp3']
        : [
            './assets/songs/music/1.mp3',
            './assets/songs/music/2.mp3',
            './assets/songs/music/3.mp3',
            './assets/songs/music/4.mp3',
            './assets/songs/music/5.mp3',
            './assets/songs/music/6.mp3',
            './assets/songs/music/7.mp3',
            './assets/songs/music/8.mp3',
            './assets/songs/music/9.mp3',
            './assets/songs/music/10.mp3',
            './assets/songs/music/11.mp3',
            './assets/songs/music/12.mp3',
            './assets/songs/music/13.mp3',
            './assets/songs/music/14.mp3',
            './assets/songs/music/15.mp3',
          ],
      playPreviousTrackButton = document.getElementById('play-previous'),
      playNextTrackButton = document.getElementById('play-next'),
      currIndex = -1;
    const audio = new Audio();

    function playPause() {
      setTimeout(function () {
        if (audio.paused) {
          playerTrack.classList.add('active');
          albumArt.classList.add('active');
          checkBuffering();
          const pauseIcon = playPauseButton.querySelector('.fa-pause');
          const playIcon = playPauseButton.querySelector('.fa-play');
          pauseIcon.classList.remove('hidden');
          playIcon.classList.add('hidden');
          // i.className = "fas fa-pause";
          audio.play();
        } else {
          playerTrack.classList.remove('active');
          albumArt.classList.remove('active');
          clearInterval(buffInterval);
          albumArt.classList.remove('buffering');
          const playIcon = playPauseButton.querySelector('.fa-play');
          const pauseIcon = playPauseButton.querySelector('.fa-pause');
          playIcon.classList.remove('hidden');
          pauseIcon.classList.add('hidden');
          // i.className = "fas fa-play";
          audio.pause();
        }
      }, 300);
    }

    function showHover(event) {
      seekBarPos = sArea.getBoundingClientRect();
      seekT = event.clientX - seekBarPos.left;
      seekLoc = audio.duration * (seekT / sArea.offsetWidth);

      sHover.style.width = seekT + 'px';

      cM = seekLoc / 60;

      ctMinutes = Math.floor(cM);
      ctSeconds = Math.floor(seekLoc - ctMinutes * 60);

      if (ctMinutes < 0 || ctSeconds < 0) return;

      if (ctMinutes < 0 || ctSeconds < 0) return;

      if (ctMinutes < 10) ctMinutes = '0' + ctMinutes;
      if (ctSeconds < 10) ctSeconds = '0' + ctSeconds;

      if (isNaN(ctMinutes) || isNaN(ctSeconds)) insTime.textContent = '--:--';
      else insTime.textContent = ctMinutes + ':' + ctSeconds;

      insTime.style.left = seekT + 'px';
      insTime.style.marginLeft = '-21px';
      insTime.style.display = 'block';
    }

    function hideHover() {
      sHover.style.width = '0';
      insTime.textContent = '00:00';
      insTime.style.left = '0px';
      insTime.style.marginLeft = '0px';
      insTime.style.display = 'none';
    }

    function playFromClickedPos() {
      audio.currentTime = seekLoc;
      seekBar.style.width = seekT + 'px';
      hideHover();
    }

    function updateCurrTime() {
      nTime = new Date();
      nTime = nTime.getTime();

      if (!tFlag) {
        tFlag = true;
        trackTime.classList.add('active');
      }

      curMinutes = Math.floor(audio.currentTime / 60);
      curSeconds = Math.floor(audio.currentTime - curMinutes * 60);

      durMinutes = Math.floor(audio.duration / 60);
      durSeconds = Math.floor(audio.duration - durMinutes * 60);

      playProgress = (audio.currentTime / audio.duration) * 100;

      if (curMinutes < 10) curMinutes = '0' + curMinutes;
      if (curSeconds < 10) curSeconds = '0' + curSeconds;

      if (durMinutes < 10) durMinutes = '0' + durMinutes;
      if (durSeconds < 10) durSeconds = '0' + durSeconds;

      if (isNaN(curMinutes) || isNaN(curSeconds)) tProgress.textContent = '00:00';
      else tProgress.textContent = curMinutes + ':' + curSeconds;

      if (isNaN(durMinutes) || isNaN(durSeconds)) tTime.textContent = '00:00';
      else tTime.textContent = durMinutes + ':' + durSeconds;

      if (isNaN(curMinutes) || isNaN(curSeconds) || isNaN(durMinutes) || isNaN(durSeconds)) trackTime.classList.remove('active');
      else trackTime.classList.add('active');

      seekBar.style.width = playProgress + '%';

      if (playProgress === 100) {
        // i.className = "fa fa-play";
        const pauseIcon = playPauseButton.querySelector('.fa-pause');
        const playIcon = playPauseButton.querySelector('.fa-play');
        if (!pauseIcon.classList.contains('hidden') && playIcon.classList.contains('hidden')) {
          pauseIcon.classList.add('hidden');
          playIcon.classList.remove('hidden');
        }
        seekBar.style.width = '0';
        tProgress.textContent = '00:00';
        albumArt.classList.remove('buffering');
        clearInterval(buffInterval);
      }
    }

    function checkBuffering() {
      clearInterval(buffInterval);
      buffInterval = setInterval(function () {
        if (nTime === 0 || bTime - nTime > 1000) albumArt.classList.add('buffering');
        else albumArt.classList.remove('buffering');

        bTime = new Date();
        bTime = bTime.getTime();
      }, 100);
    }

    function selectTrack(flag) {
      if (flag === 0 || flag === 1) ++currIndex;
      else --currIndex;

      let currAlbum;
      let currTrackName;
      let currArtwork;
      if (currIndex > -1 && currIndex < albumArtworks.length) {
        const pauseIcon = playPauseButton.querySelector('.fa-pause');
        const playIcon = playPauseButton.querySelector('.fa-play');
        if (flag === 0) {
          // i.className = "fa fa-play";
          pauseIcon.classList.add('hidden');
          playIcon.classList.remove('hidden');
        } else {
          albumArt.classList.remove('buffering');
          // i.className = "fa fa-pause";
          pauseIcon.classList.remove('hidden');
          playIcon.classList.add('hidden');
        }

        seekBar.style.width = '0';
        trackTime.classList.remove('active');
        tProgress.textContent = '00:00';
        tTime.textContent = '00:00';

        currAlbum = trackNames[currIndex];
        currTrackName = authors[currIndex];
        currArtwork = isHome ? '_10' : albumArtworks[currIndex];

        audio.src = trackUrl[currIndex];

        nTime = 0;
        bTime = new Date();
        bTime = bTime.getTime();

        if (flag !== 0) {
          audio.play();
          playerTrack.classList.add('active');
          albumArt.classList.add('active');

          clearInterval(buffInterval);
          checkBuffering();
        }

        albumName.textContent = currAlbum;
        trackName.textContent = currTrackName;
        albumArt.querySelector('img.active').classList.remove('active');
        document.getElementById(currArtwork).classList.add('active');

        bgArtworkUrl = document.getElementById(currArtwork).getAttribute('src');

        if (bgArtwork && !isHome) {
          bgArtwork.style.backgroundImage = 'url(' + bgArtworkUrl + ')';
        }
      } else {
        if (flag === 0 || flag === 1) --currIndex;
        else ++currIndex;
      }
    }

    function initPlayer() {
      selectTrack(0);

      audio.loop = false;

      playPauseButton.addEventListener('click', () => {
        playPause();
      });

      sArea.addEventListener('mousemove', function (event) {
        showHover(event);
      });

      sArea.addEventListener('mouseout', hideHover);

      sArea.addEventListener('click', playFromClickedPos);

      audio.addEventListener('timeupdate', updateCurrTime);

      if (playPreviousTrackButton) {
        playPreviousTrackButton.addEventListener('click', function () {
          selectTrack(-1);
        });
      }

      if (playNextTrackButton) {
        playNextTrackButton.addEventListener('click', function () {
          selectTrack(1);
        });
      }
    }

    initPlayer();
    return () => {
      audio.pause();
      clearInterval(buffInterval);
    };
  }, [pathname]);

  return (
    <section id="song-player" className={isHome ? 'iShome' : ''}>
      <div id="app-cover">
        <div id="bg-artwork" aria-hidden="true" className="pointer-events-none"></div>
        <div id="bg-layer" aria-hidden="true" className="pointer-events-none"></div>
        <div id="player" className="scale-[0.6] md:scale-100">
          <div id="player-track">
            <h3 id="album-name"></h3>
            <p id="track-name"></p>
            <dl id="track-time">
              <dt id="current-time"></dt>
              <dd id="track-length"></dd>
            </dl>
            <div id="s-area">
              <div id="ins-time"></div>
              <div id="s-hover"></div>
              <div id="seek-bar"></div>
            </div>
          </div>
          <div id="player-content">
            <div id="album-art">
              {posters.map((poster) => (
                <Image key={poster} src={`/assets/songs/portrait/${poster}.jpg`} className={poster === '_1' || isHome ? 'active' : ''} alt="song poster" id={poster} width={115} height={115} />
              ))}
              <div id="buffer-box">Cargando ...</div>
            </div>
            <div id="player-controls">
              {!isHome && (
                <div className="control">
                  <div className="button" id="play-previous">
                    <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-10 h-10">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061A1.125 1.125 0 0 1 21 8.689v8.122ZM11.25 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061a1.125 1.125 0 0 1 1.683.977v8.122Z"
                      />
                    </svg>
                  </div>
                </div>
              )}
              <div className="control">
                <div className="button" id="play-pause-button">
                  <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-10 h-10 fa-play">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
                    />
                  </svg>
                  <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-10 h-10 fa-pause hidden">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5" />
                  </svg>
                </div>
              </div>
              {!isHome && (
                <div className="control">
                  <div className="button" id="play-next">
                    <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-10 h-10">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061A1.125 1.125 0 0 1 3 16.811V8.69ZM12.75 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061a1.125 1.125 0 0 1-1.683-.977V8.69Z"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SongPlayer;
